module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Compilation-6cf1688a7c42684c0f4139ea50bc2bed.svg";